// src/features/learner/components/TutoringPanel.js
import React from 'react';
import './TutoringPanel.css';

export const TutoringPanel = ({ isOpen, onClose, status = 'not_done' }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="tutoring-panel-backdrop" onClick={onClose} />
      
      {/* Panel */}
      <div className="tutoring-panel">
        <div className="tutoring-panel-header">
          <h3>💬 Live Discussion</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="tutoring-panel-content">
          {status === 'done' ? (
            // Done with tutor
            <>
              <div className="status-section">
                <div className="status-label">Status:</div>
                <div className="status-value done">Done with tutor ✅</div>
              </div>
              
              <div className="result-section">
                <div className="result-label">Result:</div>
                <div className="result-value">Great discussion!</div>
              </div>
            </>
          ) : (
            // Not done yet
            <>
              <div className="status-section">
                <div className="status-label">Status:</div>
                <div className="status-value pending">Not done yet</div>
              </div>
              
              <div className="info-section">
                <p>This content requires a live discussion with your tutor.</p>
                <p className="note">Your tutor will be notified when this feature is fully available.</p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};